import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Appbar from "../Appbar";
import SideNav from "./SideNav";

const PrimaryLayout = () => {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#F8FAFC" }}>
      <Appbar />
      <SideNav />
      <Box
        component="main"
        sx={{
          marginLeft: "272px",
          marginTop: "72px",
          flex: 1,
          padding: "28px 32px",
          minHeight: "calc(100vh - 72px)",
          animation: "fadeIn 0.3s ease-out",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default PrimaryLayout;
